$(function () {

    $(".s31-starrating > input").change(function () {
        if (this.checked) {
            $("[name='sylius_product_review[rating]']:checked").removeAttr('checked');
            $("#sylius_product_review_rating_" + (this.value - 1)).attr('checked', 'checked');
        }
    });

});